import styled from "styled-components";

export const Description = styled.div`
  flex: 0 0 196px;
`;
